import { render } from "./fullscreen.vue?vue&type=template&id=401b52b0"
import script from "./fullscreen.vue?vue&type=script&lang=js"
export * from "./fullscreen.vue?vue&type=script&lang=js"
script.render = render

export default script